import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { PaymentTransaction, PropsWithUser } from "@/types";
import { PageTitle } from "@/components/page-title";
import { formatDate } from "@/utils/format-date";
import { formatMoney } from "@/utils/format-money";
import PaymentTransactionBadge from "@/components/payment-transaction-badge";
import { TableCellLink } from "@/components/table-cell-link";
import { SquareCheckIcon, SquareXIcon } from "lucide-react";

type Props = {
  payment_transactions: PaymentTransaction[];
};

function PaymentTransactionIndex({
  payment_transactions,
}: PropsWithUser<Props>) {
  return (
    <>
      <PageTitle>Transactions</PageTitle>

      <div className="mt-4 overflow-hidden rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Accounting Date</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Counterparty</TableHead>
              <TableHead>Reason</TableHead>
              <TableHead>Verified</TableHead>
              <TableHead>Type</TableHead>
              <TableHead className="text-right">Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payment_transactions.map((payment_transaction) => {
              const href = `/payment_transactions/${payment_transaction.id}`;

              return (
                <TableRow
                  key={payment_transaction.id}
                  className="has-[[data-row-link]:focus-visible]:outline-ring/50 has-[[data-row-link]:focus-visible]:outline-2 has-[[data-row-link]:focus-visible]:-outline-offset-2"
                >
                  <TableCell>
                    <TableCellLink href={href} />
                    {formatDate(payment_transaction.accounting_date)}
                  </TableCell>
                  <TableCell>
                    <TableCellLink href={href} />
                    {formatDate(payment_transaction.date)}
                  </TableCell>
                  <TableCell>
                    <TableCellLink href={href} tabIndex={-1} />
                    {payment_transaction.counterparty.name}
                  </TableCell>
                  <TableCell
                    className="w-full max-w-0 truncate"
                    title={payment_transaction.reason}
                  >
                    <TableCellLink href={href} tabIndex={-1} />
                    {payment_transaction.reason}
                  </TableCell>
                  <TableCell>
                    <div className="flex justify-center">
                      <TableCellLink href={href} tabIndex={-1} />
                      {payment_transaction.allocation?.verified ? (
                        <SquareCheckIcon className="text-accent-foreground size-5" />
                      ) : (
                        <SquareXIcon className="text-muted-foreground size-5" />
                      )}
                    </div>
                  </TableCell>
                  <TableCell>
                    <TableCellLink href={href} tabIndex={-1} />
                    <PaymentTransactionBadge type={payment_transaction.type} />
                  </TableCell>
                  <TableCell className="text-right font-mono font-semibold">
                    <TableCellLink href={href} tabIndex={-1} />
                    {formatMoney(payment_transaction.amount)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

export default PaymentTransactionIndex;
